import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  BundleStateBundleStatusEnum,
  RecipientStateRecipientStatusEnum,
} from '../../../../api/generated/signroom-orchestrator';
import { SignatureDocument } from '../../../../model/signature-area/signature-document';
import { AsyncThunkConfig } from '../../../async-thunk-config';
import { SignatureAreaError } from './signature-area-types';
import signatureAreaRepository from '../../../../repositories/signature-area/signature-area-repository';

export const signatureArea = createAsyncThunk<
  SignatureDocument[],
  { customerCode?: string; bundleCode?: string },
  AsyncThunkConfig<SignatureAreaError>
>('signature-area', async (params, thunkApi) => {
  try {
    return await signatureAreaRepository.downloadSignroomDocuments(
      thunkApi,
      params?.customerCode,
      params?.bundleCode
    );
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const rejectProposal = createAsyncThunk<
  void,
  string,
  AsyncThunkConfig<SignatureAreaError>
>('reject-proposal', async (bundleId, thunkApi) => {
  try {
    await signatureAreaRepository.rejectBundleAction(bundleId, thunkApi);

    return null;
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const retrieveBundleStatus = createAsyncThunk<
  BundleStateBundleStatusEnum | RecipientStateRecipientStatusEnum,
  string,
  AsyncThunkConfig<SignatureAreaError>
>('retrieve-bundle-status', async (bundleId, thunkApi) => {
  try {
    return await signatureAreaRepository.retrieveBundleStatusAction(
      bundleId,
      thunkApi
    );
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const registerDisposition = createAsyncThunk<
  boolean,
  string,
  AsyncThunkConfig<SignatureAreaError>
>('register-disposition', async (bundleId, thunkApi) => {
  try {
    return await signatureAreaRepository.registerDisposition(
      bundleId,
      thunkApi
    );
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const loadBundleDocumentDetails = createAsyncThunk<
  {
    bundleId: string;
    modules: any[];
    practiceNumber: string;
    type?: any;
  },
  string,
  AsyncThunkConfig<SignatureAreaError>
>('load-bundle-document-details', async (bundleId, thunkApi) => {
  try {
    return await signatureAreaRepository.getBundleDocumentDetails(
      bundleId,
      thunkApi
    );
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const loadOrdineRto = createAsyncThunk<
  { bundleId: string; rtoResult: any },
  { bundleId: string; practiceNumber: string },
  AsyncThunkConfig<SignatureAreaError>
>('load-ordine-rto', async ({ bundleId, practiceNumber }, thunkApi) => {
  try {
    const rtoResult = await signatureAreaRepository.getOrdineRtoDetails(
      practiceNumber,
      thunkApi
    );
    return { bundleId, rtoResult };
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});
